import {
  Navbar,
  Header,
  WhatWeDo,
  Pricing,
  GettingStarted,
  Footer,
  Testimonials,
  LevelUp,
} from 'components/layouts/home';
import { useEffect } from 'react';

const HomeScreen = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="relative">
      <Navbar />
      <Header />
      <WhatWeDo />
      <Pricing />
      <GettingStarted />
      <Testimonials />
      <LevelUp />
      <Footer />
    </div>
  );
};

export default HomeScreen;
